import $ from 'jquery'
import ParamPersonnel from '@/views/parametres/configs/param-personnels'
import PrescripteursExternes from '@/views/parametres/prescripteurs'
import ParamAccordionSection from '@/components/param-accordion-section'

export default {
    name: 'equipe-acces',
    components: {
        ParamPersonnel, PrescripteursExternes, ParamAccordionSection
    },
    props: [],
    data() {
        return {}
    },
    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);
    },
    methods: {}
}
